<script lang="ts" setup>
withDefaults(
  defineProps<{
    isLight?: boolean
    title: string
  }>(),
  { isLight: false }
)
</script>

<template>
  <a
    class="
      flex items-center rounded-xl bg-main-green p-[10px] text-white !no-underline
      md:rounded-2xl md:py-2 md:pl-3 md:pr-[7px]
    "
    :class="{ '!bg-white !text-main-dark': isLight }"
    href="#"
  >
    <span class="mr-1 block text-sm md:text-base md:leading-[1.71]">
      {{ title }}
    </span>

    <SvgIcon
      class="!size-5 md:!size-6"
      :class="{ '!fill-main-gray': isLight }"
      :name="isLight ? 'outlined/close' : 'outlined/drop'"
    />
  </a>
</template>
